import React from "react";
import "../styles/contactStyle.css";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";

const Contact = () => {
  const [isVerified, setIsVerified] = useState(false);
  function handleSubmit(event) {
    event.preventDefault();
    // if (isVerified) {
      let validations = "";
      if(event.target.name.value.length <= 0){validations += "Enter non-empty name.\n";}
      if(!new RegExp(
        "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
      ).test(event.target.email.value)){validations += "Enter valid email.\n";}
      if(event.target.message.value.length <= 0){
        validations += "Enter non-empty message\n";
      }
      if (validations.length === 0) {
        emailjs
          .sendForm(
            "service_ropw8hi",
            "template_ho8h4oa",
            event.target,
            "user_m3DanaTq78DipyM9RhUju"
          )
          .then(
            (result) => {
              alert(result.text);
            },
            (error) => {
              alert(error.text);
            }
          );
        event.target.reset();
        window.grecaptcha.reset();
      } else {
        alert(validations);
      }
    // } else {
    //   alert("Please solve ReCaptcha");
    // }
    return false;
  }
  function verifyCallback() {
    setIsVerified(true);
  }
  return (
    <div className="container-contact">
      <div className="mt-28 flex flex-col items-center justify-center w-full">
        <div className=" form-wrapper flex flex-row h-4/5 w-full py-10 px-24 rounded-2xl items-center justify-between w-full">
          <div className="form-image-wrapper w-1/2 h-full">
            <div className="form-image"></div>
          </div>
          <div className="form-right-content w-1/2">
            <h1 className="font-bold text-gray-700 text-xl md:text-3xl mb-4 ">
              Get in touch
            </h1>
            <form onSubmit={handleSubmit}>
              <div className="wrap-input my-2 relative w-full">
                <input
                  className="input"
                  type="text"
                  name="name"
                  placeholder="Name"
                />
                <span className="focus-input block absolute w-full h-full"></span>
                <span className="symbol-input">
                  <i className="fa fa-user" aria-hidden="true"></i>
                </span>
              </div>
              <div className="wrap-input w-full my-2 relative">
                <input
                  className="input"
                  type="text"
                  name="email"
                  placeholder="Email"
                />
                <span className="focus-input"></span>
              </div>
              <div className="wrap-input w-full my-2 relative">
                <textarea
                  className="input "
                  type="text"
                  name="message"
                  placeholder="Message"
                ></textarea>
                <span className="focus-input"></span>
              </div>
              {/* <ReCAPTCHA
                sitekey="6LcbbCkaAAAAAB6u2i9L28Un3tKfwBbRGn7keMCE"
                size={window.innerWidth < 576 ? "compact" : "normal"}
                onChange={verifyCallback}
              /> */}
              <div className="button-wrapper rounded-full mt-5 ">
                <input
                  type="submit"
                  className="button bg-blue-400 hover:bg-blue-800 w-full rounded-full py-3 text-white"
                  value="Submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
